import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { getSettings, updateSettings, testKh } from '@/lib/api/settings'

/** Settings descriptors (Screen 6). Changes take effect immediately server-side. */
export function useSettings() {
  return useQuery({
    queryKey: ['settings'],
    queryFn: getSettings,
    staleTime: 30_000,
  })
}

/**
 * Save changed settings. On success the server returns the full refreshed shape,
 * which we seed straight into the cache so the page's draft re-syncs from it.
 */
export function useUpdateSettings() {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: (changes: Record<string, string>) => updateSettings(changes),
    onSuccess: (data) => {
      queryClient.setQueryData(['settings'], data)
    },
  })
}

/** KH API connection test — shared by the Settings and Health screens. */
export function useTestKh() {
  return useMutation({ mutationFn: testKh })
}
